import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _get from "lodash/fp/get";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/** @jsx jsx */

/** @jsxFrag React.Fragment */


import { Global } from '@emotion/core';
import { useConfig, useCurrentDoc } from 'docz';
import { NavGroup } from 'gatsby-theme-docz/src/components/NavGroup';
import { NavLink } from 'gatsby-theme-docz/src/components/NavLink';
import { NavSearch } from 'gatsby-theme-docz/src/components/NavSearch';
import * as styles from 'gatsby-theme-docz/src/components/Sidebar/styles';
import React, { useEffect, useRef } from 'react';
import { Box, jsx } from 'theme-ui';
import { NO_GROUP } from '../../hooks/useExtendedMenus';
import { Container, Group, Label, SearchContainer } from './custom-styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Sidebar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var menus = _ref.menus,
      query = _ref.query,
      handleChange = _ref.handleChange,
      onClick = _ref.onClick,
      open = _ref.open;
  var currentDocRef = useRef();

  var _useConfig = useConfig(),
      _useConfig$menuDispla = _useConfig.menuDisplayName,
      menuDisplayName = _useConfig$menuDispla === void 0 ? {} : _useConfig$menuDispla,
      _useConfig$themeConfi = _useConfig.themeConfig;

  _useConfig$themeConfi = _useConfig$themeConfi === void 0 ? {} : _useConfig$themeConfi;
  var _useConfig$themeConfi2 = _useConfig$themeConfi.menu;
  _useConfig$themeConfi2 = _useConfig$themeConfi2 === void 0 ? {} : _useConfig$themeConfi2;
  var search = _useConfig$themeConfi2.search;
  var currentDoc = useCurrentDoc();
  useEffect(function () {
    if (ref.current && currentDocRef.current) {
      ref.current.scrollTo(0, currentDocRef.current.offsetTop);
    }
  }, [ref]);
  return jsx(Container, null, jsx(Box, {
    onClick: onClick,
    sx: styles.overlay({
      open: open
    })
  }, open && jsx(Global, {
    styles: styles.global
  })), jsx(Box, {
    className: "sidebar",
    ref: ref,
    sx: _objectSpread(_objectSpread({}, styles.wrapper({
      open: open
    })), {}, {
      px: 0,
      transitionProperty: 'background-color',
      transitionTimingFunction: 'ease-out',
      transitionDuration: '0.4s'
    }),
    "data-testid": "sidebar"
  }, jsx("div", null, search !== false ? jsx(SearchContainer, null, jsx(NavSearch, {
    placeholder: "Type to search...",
    value: query,
    onChange: handleChange
  })) : null, menus && Object.keys(menus).map(function (key) {
    return jsx(Group, {
      key: key
    }, key !== NO_GROUP ? jsx(Label, null, key) : null, (menus[key] || []).map(function (menu) {
      if (!menu) return null;

      if (!menu.route) {
        return jsx("div", {
          key: menu.id,
          className: "nav-group"
        }, jsx(NavGroup, {
          item: menu,
          sidebarRef: ref
        }));
      }

      if (menu.route === currentDoc.route) {
        return jsx(NavLink, {
          key: menu.id,
          item: menu,
          ref: currentDocRef
        }, _get(menu.name, menuDisplayName) || menu.name);
      }

      return jsx(NavLink, {
        key: menu.id,
        item: menu
      }, _get(menu.name, menuDisplayName) || menu.name);
    }));
  }))));
});

if (typeof Sidebar !== 'undefined' && Sidebar && Sidebar === Object(Sidebar) && Object.isExtensible(Sidebar) && !Sidebar.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Sidebar, '__filemeta', {
    configurable: true,
    value: {
      name: "Sidebar",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Sidebar/index.js"
    }
  });
}